import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './utils';

export interface ScoreDomain {
  value: string;
  country: string;
}
export interface ScoreRequest {
  api_key: string;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  phone?: string | null;
  browser?: boolean | null;
  ip?: string | null;
  customer_id: string;
  domain?: ScoreDomain | null;
  user_agent?: string | null;
  max_enrichment_time?: number;
}

export interface ResolutionIdRequest {
  api_key: string;
  customer_id: string;
}
export interface ResolutionIdResponse {
  status: string;
  resolution_id: string;
}

export interface ScoreVersionResponse {
  browser_score: 'Browser score';
  device_score: 'Device score';
  email_score: 'Email Address score';
  ip_score: 'IP Address score';
  name_score: 'Name score';
  phone_score: 'Phone Number score';
  digital_score: 'Digital score';
}
interface ScoreConfigResponse {
  item: {
    app_key: string;
    phone: boolean;
    email: boolean;
    ip: boolean;
    device: boolean;
    name: boolean;
    browser: boolean;
    tax_id: boolean;
    vat_code: boolean;
    phone_data_breaches: boolean;
    phone_disposable: boolean;
    phone_mnp: boolean;
    phone_validation: boolean;
  };
  filters: {
    app_key: string;
  };
}
interface UpdateScoreConfigPayload {
  app_key: string;
  ip: boolean;
  email: boolean;
  name: boolean;
  device: boolean;
  phone: boolean;
  browser: boolean;
  tax_id: boolean;
  vat_code: boolean;
  phone_data_breaches: boolean;
  phone_disposable: boolean;
  phone_mnp: boolean;
  phone_validation: boolean;
}

export const scoreApi = createApi({
  reducerPath: 'scoreApi',
  baseQuery: baseQuery,
  tagTypes: ['ScoreConfig'],
  endpoints: (builder) => ({
    getScoreConfiguration: builder.query<ScoreConfigResponse, { appKey: string }>({
      query: (params) => ({
        url: `/v1/admin/score-configuration/${params.appKey}`,
      }),
      providesTags: ['ScoreConfig'],
    }),
    updateScoreRequest: builder.mutation<ResolutionIdResponse, ScoreRequest>({
      query(data) {
        return {
          url: '/v1/score',
          method: 'POST',
          body: data,
        };
      },
    }),
    updateScoreConfiguration: builder.mutation<ResolutionIdResponse, UpdateScoreConfigPayload>({
      query(data) {
        return {
          url: '/v1/admin/score-configuration/upsert',
          method: 'POST',
          body: data,
        };
      },
      invalidatesTags: ['ScoreConfig'],
    }),
    updateResolutionIdRequest: builder.mutation<ResolutionIdResponse, ResolutionIdRequest>({
      query(data) {
        return {
          url: '/v1/score/resolutionid',
          method: 'POST',
          body: data,
        };
      },
    }),
  }),
});

export const { useUpdateScoreRequestMutation, useUpdateResolutionIdRequestMutation } = scoreApi;
